import { apiGet, apiPost } from './client';
import { SessionUser, LoginRequest, RegisterRequest, ApiResponse } from '@tinyrewards/shared';

export function login(email: string, password: string): Promise<ApiResponse<SessionUser>> {
    return apiPost<SessionUser>('/auth/login', { email, password } satisfies LoginRequest);
}

export function register(data: RegisterRequest): Promise<ApiResponse<SessionUser>> {
    return apiPost<SessionUser>('/auth/register', data);
}

export function logout(): Promise<ApiResponse<void>> {
    return apiPost<void>('/auth/logout', {});
}

export function getMe(): Promise<ApiResponse<SessionUser>> {
    return apiGet<SessionUser>('/auth/me');
}

export function forgotPassword(email: string): Promise<ApiResponse<void>> {
    return apiPost<void>('/auth/forgot-password', { email });
}

export function resetPassword(token: string, password: string): Promise<ApiResponse<void>> {
    return apiPost<void>('/auth/reset-password', { token, password });
}

export function sessionFromToken(accessToken: string): Promise<ApiResponse<void>> {
    return apiPost<void>('/auth/session-from-token', { accessToken });
}
